import { Outlet } from "react-router";

export function WorkOrdersRoute() {
  return <Outlet />;
}
